export const useUserModeChange = defineStore("userMode", () => {
  // data
  const isUserMode = ref<boolean>(false);

  return {
    isUserMode,
  };
});
